import React from 'react'
import clsx from 'clsx'
import { PopoverTiny } from 'components/Popover'
import EditPenIcon from 'components/utils/Icons/EditPenIcon'
// import CloudArrowDowsnIcon from 'components/utils/Icons/CloudArrowDownIcon'
import TrashIcon from 'components/utils/Icons/TrashIcon'
import TravelIcon from 'components/utils/Icons/TravelIcon'
import { useMutation } from '@apollo/client'
import { DISABLE_OR_ENABLE_BANNER } from 'mutations/banners'
import { useNavigate } from 'react-router-dom'
import { showSnackbar } from 'components/snackbar'
import i18n from 'components/i18n'
import { Banner } from 'models/banner'
import { formatDate } from 'lib/utils'

const InactiveBanners = ({bannerData, bannerLoading, isOdd, deleteBanner,  setState, setIsDate, setCta, updateBannerEnabled}) => {

  const [updateEnable, updateEnableRes] = useMutation(DISABLE_OR_ENABLE_BANNER, {
    onCompleted: () => showSnackbar(i18n.t('success'), 3000, 'success'),
  })
  const orgProducts: any = ['FT', 'CR', 'UL', 'XL', 'VL', 'CL', 'GT', 'OP', 'IN', 'DM']
  const btnCn = clsx({
    'w-full px-4 py-2 cursor-pointer hover:bg-alabastergray flex flex-row gap-3 items-center justify-start text-deepgray text-md whitespace-nowrap': true,
  })
  const navigate = useNavigate()

  return (
    <section className="mt-6 rounded border border-[#E3E4E5]">
      <div className="flex text-sm bg-alabastergray text-medgray font-bold border-b rounded-t border-[#E3E4E5]">
        <div className="p-4 w-2/12 border-r-2 border-[#E3E4E5]">
          Date created
        </div>
        <div className="p-4 w-2/12 flex border-r-2 border-[#E3E4E5]">
          Employee
        </div>
        <div className="p-4 w-4/12 flex border-r-2 border-[#E3E4E5]">
          Banner ID
        </div>
        <div className="p-4 w-2/12 flex border-r-2 border-[#E3E4E5]">
          Expiry date
        </div>
        <div className="p-4 w-2/12 flex border-r-2 border-[#E3E4E5]">
          Tiers
        </div>
        <div className="p-4 w-2/12 flex border-r-2 border-[#E3E4E5]">
          Platform(s)
        </div>
        <div className="p-4 w-1/12 flex">
          Actions
        </div>
      </div>
      {bannerLoading && <div>Loading your banners</div>}
      {bannerData && bannerData.banners.filter(b => !b.enabled).map((banner: Banner, i) => {
        const date = new Date(banner.expirationTime)
        return (
          <div key={i} className={`flex text-sm ${isOdd(i) ? 'bg-white' : 'bg-alabastergray' } text-medgray font-bold`}>
            <div className="p-4 flex items-center justify-start w-2/12">
              {formatDate(banner.createdAt)}
            </div>
            <div className="p-4 flex items-center justify-start w-2/12">
              {banner.creatorName}
            </div>
            <div className="px-4 flex flex-col items-start justify-center py-2 w-4/12">
              <div className="flex">
                {banner.bannerId}
              </div>
              <div className="text-sm text-medgray font-normal flex">
                {banner.bannerText}
              </div>
            </div>
            <div className="p-4 w-2/12 flex items-center justify-start">
              {(banner.expirationTime < 2543817720000) ? date.toLocaleDateString('en-US') : '-'}  {/* if expiration date is before 2050 */}
            </div>
            <div className="p-4 w-2/12">
                {orgProducts.every(p => banner.showToProduct.includes(p))
                ? <div className="bg-[#E3E4E5] rounded uppercase text-deepgray px-2 mr-0.5 mt-0.5 inline-block">
                    All
                  </div>
                : banner.showToProduct.map((product, i) => {
                  return (
                    <div key={i * 123821} className="bg-[#DFF0FF] rounded uppercase text-deepgray px-2 mr-0.5 mt-0.5 inline-block">
                      {product}
                    </div>
                  )
                })}
            </div>
            <div className="p-4 w-2/12 text-center space-y-1">
              {banner.showToPlatform.slice().sort().map(p => <div key={`${banner.bannerId}-inactive-${p}`} className={`${p === 'dashboard'
                ? 'bg-lake-light'
                : p === 'web'
                  ? 'bg-team' : ''} rounded-lg shadow-sm p-1/2 max-w-[100px]`}>
                {p}
              </div>)}
            </div>
            <div className="p-4 w-1/12 flex items-center justify-center">
              <PopoverTiny divClassName="z-10 w-52 origin-top-right bg-white rounded-md shadow-lg outline-none" align="center" content={
                <div>
                  <ul className="w-full rounded">
                    <li
                      className="rounded-t">
                      <button
                        className={btnCn}
                        onClick={
                          () => {
                            updateEnable({
                              variables: {
                                bannerId: banner.bannerId,
                                bannerData: {
                                  enabled: true,
                                },
                              },
                            }).then((res) => {
                              if (!res || (res.errors?.length || 0) > 0) return
                              updateBannerEnabled(banner.bannerId, true)
                            })
                          }
                        }
                        >
                        <>
                          <TravelIcon className="fill-medgray w-5 h-5" h={20} w={20} />
                          Activate banner
                        </>
                      </button>
                    </li>
                    <li>
                      <button
                        className={btnCn}
                        onClick={
                          () => {
                            if (banner.ctaButton) {
                              setCta(true)
                            }
                            if (!banner.ctaButton) {
                              setCta(false)
                            }
                            if (banner.expirationTime < 2543817720000) {
                              setIsDate(true)
                            }
                            if (banner.expirationTime > 2543817720000) {
                              setIsDate(false)
                            }
                            navigate('#edit')
                            setState({
                              bannerId: banner.bannerId,
                              type: banner.type,
                              bannerText: banner.bannerText,
                              bannerColor: banner.bannerColor,
                              ctaButton: banner.ctaButton,
                              showToPlatform: banner.showToPlatform,
                              showToProduct: banner.showToProduct,
                              enabled: banner.enabled,
                              expirationTime: (banner.expirationTime < 2543817720000) && banner.expirationTime,
                              minRangeCopy: banner.minRangeCopy,
                              maxRangeCopy: banner.maxRangeCopy,
                              dismissForDays: banner.dismissForDays,
                            })
                          }
                        }
                        >
                        <>
                          <EditPenIcon className="fill-medgray w-5 h-5" h={20} w={20} />
                          Edit banner
                        </>
                      </button>
                    </li>
                    {/* <li>
                      <button
                        className={btnCn}>
                        <>
                          <CloudArrowDownIcon className="fill-medgray w-5 h-5" h={20} w={20} />
                          Export analytics
                        </>
                      </button>
                    </li> */}
                    <li>
                      <button
                        className="w-full px-4 py-2 cursor-pointer hover:bg-alabastergray flex flex-row gap-3 items-center justify-start whitespace-nowrap text-coral text-md rounded-b"
                        onClick={() => deleteBanner(banner.bannerId)}
                        >
                        <>
                          <TrashIcon className="fill-coral w-5 h-5" h={20} w={20} />
                          Delete
                        </>
                      </button>
                    </li>
                  </ul>
                </div>
              }/>
            </div>
          </div>
        )
      })}
    </section>
  )
}

export default InactiveBanners
